"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendAirplane = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SendAirplane = _ref => {
  let {
    spotColor = "#FA6B54",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M22.201 3.927c3.35.754 8.67 2.028 12.548 5.82 3.878 3.804 6.665 10.478 4.485 14.304-2.192 3.815-9.352 4.771-15.657 6.302C17.26 31.895 11.808 34.01 7.998 32.3 4.2 30.59 2.063 25.064.93 20.303-.218 15.543-.34 11.56.771 8.228 1.872 4.898 4.233 2.23 6.92 1.352c2.698-.866 5.732.045 8.127.81 2.394.766 3.795 1 7.155 1.765Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M34 2.5 6 19l9.5 3M34 2.5 15.5 22M34 2.5v25l-9.333-3M34 2.5 20 23m-4.5-1 4.5 7.5m0-6.5v6.5m0-6.5 4.667 1.5M20 29.5l4.667-5M26 31l-3 4m-7-5-3 3.5m-2.813 3.281L10 37m1-11-4 4"
  }));
};
exports.SendAirplane = SendAirplane;
SendAirplane.displayName = "SendAirplane";